import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import AddFavourite from "../../utility/js/addFav.js";
import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import PrinterDetails from "../../common/printer-details";
import addressComp from "../address-comp.vue";
import moment from "moment";
import salesOrderEditService from "./sales-order-edit-service.js";
import salesService from "./sales-order-service.js";
import { bus } from "../../../main.js";
import BackToTop from "../../common/back-to-top.vue";
import DisplayCommentsComp from "../comments-display-comp.vue";
import html2pdf from "html2pdf.js";
import ucsLogo from "@/assets/images/ucslogoPDF.png";
import OrderTreeNode from "../order-tree-structure-comp.vue";
export default {
  data() {
    return {
      route: "",
      stockMessage: "",
      fix_price: 0,
      last_price: 0,
      avg_cost: 0,
      showDeleteWarningMessage: true,
      deleteReasonRule: [
        (v) => !!v || "Reason is required",
        (v) => (v && v.trim().length >= 5) || "Reason must be at least 5 characters",
      ],
      required: [(v) => !!v || "Field is required"],
      priceValid: [(v) => parseInt(v) >= 0 || "Field is required"],
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      mainPage: "",
      favouriteList: [],
      pageUrl: "",
      subPage: "",
      showAdd: false,
      subPageUrl: "",
      commentList: [],
      bookmark: false,
      showBookMark: false,
      backSlash: true,
      backSlashParent: true,
      orderTypeList: [],
      custSearchKey: "",
      customerList: [],
      shipList: [],
      returnList: [],
      showLineDelete: false,
      shipSearchKey: "",
      returnSearchKey: "",
      outboundList: [],
      flexHeader: [
        {
          text: "Flex Attribute",
          align: "start",
          value: "flex_code",
          class: "primary customwhite--text",
        },
        {
          text: "Flex Value",
          value: "flex_data",
          class: "primary customwhite--text",
        },
      ],
      headersLineItems: [
        {
          text: "Line#",
          align: "start",
          value: "sequence_number",
          class: "primary customwhite--text",
          cellClass: "line-item-text-cell",
          width: "48px",
        },
        {
          text: "Line Type",
          align: "center",
          value: "order_line_text",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "78px",
        },
        {
          text: "",
          align: "center",
          value: "ouboundPresent",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "28px",
        },
        {
          text: "Part Number To Ship",
          align: "start",
          value: "sh_part_number",
          class: "primary customwhite--text",
          cellClass: "line-item-text-cell",
          width: "18%",
        },
        {
          text: "Return Part Number",
          align: "start",
          value: "return_part_number",
          class: "primary customwhite--text",
          cellClass: "line-item-text-cell",
          width: "15%",
        },
        {
          text: "Warehouses",
          align: "start",
          value: "warehouse_summary",
          class: "primary customwhite--text",
          cellClass: "line-item-text-cell",
          width: "13%",
        },
        {
          text: "Ordered",
          align: "center",
          value: "quantity",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "52px",
        },
        {
          text: "Available",
          align: "center",
          value: "avail",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "58px",
        },
        { text: "Rcvd", align: "center", value: "Rcvd", class: "primary customwhite--text", cellClass: "line-item-center-cell", width: "46px" },
        { text: "Picked", align: "center", value: "Picked", class: "primary customwhite--text", cellClass: "line-item-center-cell", width: "50px" },
        {
          text: "Shipped",
          align: "center",
          value: "Shipped",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "52px",
        },
        {
          text: "Open Shipments",
          align: "center",
          value: "Open_Shipments",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "56px",
        },
        {
          text: "Open Returns",
          align: "center",
          value: "Open_Receipts",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "52px",
        },
        {
          text: "Flags",
          align: "center",
          value: "line_flags",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "86px",
        },
        {
          text: "Actions",
          align: "center",
          value: "actions",
          class: "primary customwhite--text",
          cellClass: "line-item-center-cell",
          width: "48px",
        },
      ],
      partialLineHeaders: [
        {
          text: "Line#",
          align: "start",
          value: "sequence_number",
          class: "primary customwhite--text",
        },
        {
          text: "Line Type",
          value: "order_line_text",
          class: "primary customwhite--text",
        },
        {
          text: "Part Number To Ship",
          value: "sh_part_number",
          class: "primary customwhite--text",
        },
        {
          text: "Return Part Number",
          value: "return_part_number",
          class: "primary customwhite--text",
        },
        {
          text: "Ordered Qty",
          value: "quantity",
          class: "primary customwhite--text",
        },
        // { text: "Received", value: "Rcvd", class: "primary customwhite--text" },
        {
          text: "Available",
          value: "avail",
          class: "primary customwhite--text",
        },
      ],
      headersWarrenty: [
        {
          text: "Serial No",
          align: "start",
          value: "serial_number",
          class: "primary customwhite--text",
        },
        {
          text: "Asset Tag",
          value: "asset_tag",
          class: "primary customwhite--text",
        },
        {
          text: "Problem Description",
          value: "problem_description",
          class: "primary customwhite--text",
        },
        {
          text: "Tracking",
          value: "return_tracking_number",
          class: "primary customwhite--text",
        },
        {
          text: "Return Carrier",
          value: "return_carrier",
          class: "primary customwhite--text",
        },
        {
          text: "Warranty",
          value: "warranty_status",
          class: "primary customwhite--text",
        },
      ],
      headersBuild: [
        {
          text: "Part Number",
          align: "start",
          value: "bo_part_number",
          class: "primary customwhite--text",
        },
        {
          text: "Part Description",
          value: "bo_part_description",
          class: "primary customwhite--text",
        },
        { text: "Qty", value: "bo_qty", class: "primary customwhite--text" },
      ],
      inboundDetailsHeaders: [
        {
          text: "Process Type",
          align: "start",
          value: "process_type",
          class: "primary customwhite--text",
        },
        {
          text: "Request",
          value: "request",
          class: "primary customwhite--text",
        },
        // { text: "XML", value: "request_xml", class: "primary customwhite--text" },
        {
          text: "Record Date",
          value: "created_date",
          class: "primary customwhite--text",
        },
      ],
      outboundDetailsHeaders: [
        {
          text: "Process Type",
          align: "start",
          value: "process_type",
          class: "primary customwhite--text",
        },
        {
          text: "Request",
          value: "request",
          class: "primary customwhite--text",
        },
        {
          text: "Record Date",
          value: "created_date",
          class: "primary customwhite--text",
        },
        {
          text: "Response",
          value: "response",
          class: "primary customwhite--text",
        },
        {
          text: "Sent Date",
          value: "retrieved",
          class: "primary customwhite--text",
        },
        {
          text: "Status",
          value: "msg_status",
          class: "primary customwhite--text",
        },
      ],
      ouboundLogHeader: [
        {
          text: "Client Response Json",
          align: "start",
          value: "client_response_json",
          class: "primary customwhite--text",
        },
        {
          text: "Retrieved",
          value: "retrieved",
          class: "primary customwhite--text",
        },
      ],
      inboundList: [],
      inboundDataList: [],
      outboundDataList: [],
      panel: [0, 1, 2, 3, 4],
      lineItemPanel: [0, 1],
      showFlexDialog: false,
      showPartsItem: false,
      lineTypeList: [],
      showPartShip: false,
      showPartRet: false,
      showDialogDetailsBox: false,
      dialogBoxHeader: "",
      displayData: "",
      showOutboundLog: false,
      outboundData: [],
      showFlex: false,
      showActionsList: [],
      partNumbertoShip: "",
      salesOrderId: "",
      showPartDetails: false,
      showBuildIcon: false,
      showBuildExpand: false,
      shipWareList: [],
      partBuildPartNum: "",
      buildPartResultList: [],
      buildToQty: "",
      returnWareList: [],
      partReturnSearchKey: "",
      returnResultList: [],
      returnPartNum: "",
      returnPartDesc: "",
      showexpIcon: false,
      showExpectedSr: false,
      serial_num: "",
      tracking_num: "",
      asset_tag: "",
      warr_status: "",
      returnCarrier: "",
      temp_waybill_id: 1,
      showLinkDialog: false,
      shippingReq: false,
      returnReq: false,
      selectedLink: "",
      pickedDataList: [],
      receivedDataList: [],
      shippedDataList: [],
      contactDate: false,
      followupDate: false,
      conDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      contactTime: false,
      conTime: moment().format("HH:mm"),
      followDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      soCallLogsDialog: false,
      methodList: [
        {
          text: "",
          value: "",
        },
        {
          text: "Call",
          value: "Call",
        },
        {
          text: "Email",
          value: "Email",
        },
      ],
      outcomeList: [
        {
          text: "",
          value: "",
        },
        {
          text: "Direct",
          value: "Direct",
        },
        {
          text: "Voicemail",
          value: "Voicemail",
        },
        {
          text: "No Answer",
          value: "No Answer",
        },
      ],
      headersPicked: [
        {
          text: "SO Line#",
          align: "start",
          value: "SO Line#",
          class: "primary customwhite--text",
        },
        {
          text: "Part No",
          value: "Part No",
          class: "primary customwhite--text",
        },
        { text: "BCN", value: "BCN", class: "primary customwhite--text" },
        {
          text: "Serial No#",
          value: "Serial#",
          class: "primary customwhite--text",
        },
        { text: "ESN", value: "ESN", class: "primary customwhite--text" },
        { text: "Picked", value: "Picked", class: "primary customwhite--text" },
        { text: "Tech", value: "By", class: "primary customwhite--text" },
        {
          text: "From Bin(LPN)",
          value: "From Bin (LPN)",
          class: "primary customwhite--text",
        },
        { text: "To LPN", value: "To LPN", class: "primary customwhite--text" },
        { text: "Qty", value: "Qty", class: "primary customwhite--text" },
      ],
      headersReceived: [
        {
          text: "SO Line#",
          align: "start",
          value: "SO Line#",
          class: "primary customwhite--text",
        },
        {
          text: "Receiver#",
          value: "Receiver#",
          class: "primary customwhite--text",
        },
        {
          text: "Part No",
          value: "Part No",
          class: "primary customwhite--text",
        },
        { text: "BCN", value: "BCN", class: "primary customwhite--text" },
        {
          text: "Serial",
          value: "Serial#",
          class: "primary customwhite--text",
        },
        { text: "ESN", value: "ESN", class: "primary customwhite--text" },
        { text: "Date", value: "Date", class: "primary customwhite--text" },
        { text: "Tech", value: "Tech", class: "primary customwhite--text" },
        {
          text: "Packing Slip",
          value: "Packing Slip",
          class: "primary customwhite--text",
        },
        {
          text: "Waybill#",
          value: "Waybill#",
          class: "primary customwhite--text",
        },
        { text: "Qty", value: "Qty", class: "primary customwhite--text" },
        { text: "Credit", value: "Credit", class: "primary customwhite--text" },
        {
          text: "Extra Credit",
          value: "Ext Credit",
          class: "primary customwhite--text",
        },
      ],
      headersShipped: [
        {
          text: "SO Line#",
          align: "start",
          value: "SO Line#",
          class: "primary customwhite--text",
        },
        {
          text: "Shipper#",
          value: "Shipper#",
          class: "primary customwhite--text",
        },
        {
          text: "Part No",
          value: "Part No",
          class: "primary customwhite--text",
        },
        { text: "BCN", value: "BCN", class: "primary customwhite--text" },
        {
          text: "Serial",
          value: "Serial#",
          class: "primary customwhite--text",
        },
        { text: "ESN", value: "ESN", class: "primary customwhite--text" },
        {
          text: "Shipped",
          value: "Shipped",
          class: "primary customwhite--text",
        },
        { text: "Tech", value: "Tech", class: "primary customwhite--text" },
        {
          text: "Packing Slip",
          value: "Packing Slip",
          class: "primary customwhite--text",
        },
        {
          text: "Waybill#",
          value: "Waybill",
          class: "primary customwhite--text",
        },
        {
          text: "Return Waybill#",
          value: "RtnWaybill",
          class: "primary customwhite--text",
        },
        { text: "Qty", value: "Qty", class: "primary customwhite--text" },
        { text: "Credit", value: "Credit", class: "primary customwhite--text" },
        {
          text: "Extra Credit",
          value: "Ext Credit",
          class: "primary customwhite--text",
        },
        {
          text: "Outbound Label",
          value: "Outbound_Label",
          class: "primary customwhite--text",
        },
        {
          text: "Inbound Label",
          value: "Inbound_Label",
          class: "primary customwhite--text",
        },
      ],
      showPartialShip: false,
      disableSubmit: true,
      partialLineData: [],
      selectedRows: [],
      manualSelected: false,
      automaticSelected: false,
      orderRedirectDialog: false,
      partialShipHistoryDialog: false,
      partialShipHistoryData: [],
      treePartialShipmentData: [],
      openPartialShipmentData: [],
      headersPartialShipment: [
        {
          text: "SO Number",
          align: "start",
          value: "new_sono",
          class: "primary customwhite--text",
        },
        {
          text: "Order ID",
          value: "new_order_id",
          class: "primary customwhite--text",
        },
      ],
      // SO JSON
      salesOrderJson: {
        order_number: "",
        proj_id: "",
        bu_id: "",
        inbound_status: "",
        rma: "",
        ordered_date: "",
        outbound_status: "",
        customer_number: "",
        requested_ship_date: "",
        last_receipt_date: "",
        order_type: "",
        order_type_id: "",
        customer_po: "",
        customer_order_number: "",
        fob: "",
        pay_term_id: "",
        ritm: "",
        shipment_terms: "",
        employee_name: "",
        employee_id: "",
        new_hire: false,
        new_hire_date: "",
        enable_partial_ship: 0,
        is_shipping_hold: false,
        // CustomerInfo: [
        //   {
        //     title: "",
        //     first: "",
        //     last: "",
        //     cust_id: "",
        //     custno: "",
        //     company: "",
        //     address1: "",
        //     address2: "",
        //     city: "",
        //     state: "",
        //     zip: "",
        //     country: "",
        //     phone1: "",
        //     phone2: "",
        //     cell: "",
        //     fax: "",
        //     email: "",
        //   },
        // ],
        shipment_address: [
          {
            sh_title: "",
            sh_first: "",
            sh_last: "",
            sh_custno: "",
            sh_company: "",
            sh_address1: "",
            sh_address2: "",
            sh_city: "",
            sh_state: "",
            sh_zip: "",
            sh_country: "",
            sh_phone1: "",
            sh_phone2: "",
            sh_cell: "",
            sh_fax: "",
            sh_email: "",
            sh_cust_id: "",
          },
        ],
        return_address: [
          {
            rt_title: "",
            rt_first: "",
            rt_last: "",
            rt_comp_id: "",
            rt_custno: "",
            rt_company: "",
            rt_address1: "",
            rt_address2: "",
            rt_city: "",
            rt_state: "",
            rt_zip: "",
            rt_country: "",
            rt_phone1: "",
            rt_phone2: "",
            rt_cell: "",
            rt_fax: "",
            rt_email: "",
          },
        ],
        shipping_priority: "",
        return_shipping_priority: "",
        signature_required: false,
        saturday_delivery: false,
        order_notes: "",
        problem_description: "",
        so_notes: "",
        flex_field: [],
        order_line: [],
        timeline_info: [],
        showTATInfo: false,
      },
      //TEMPJSON
      temp_order_line: {
        sequence_number: "",
        order_line_type_text: "",
        order_line_type: "",
        line_number: "",
        sh_part_id: "",
        sh_part_number: "",
        sh_part_description: "",
        sh_from_warehouse_id: "",
        sh_from_warehouse: "",
        sh_from_inventory_bucket: "",
        sh_quantity: "",
        sh_price: "",
        build_orders: {
          build_order_notes: "",
          build_order: [],
        },
        return_part_id: "",
        return_part_number: "",
        return_part_description: "",
        return_to_warehouse_id: "",
        return_to_warehouse: "",
        return_to_inventory_bucket: "",
        return_quantity: "",
        return_price: "",
        return_rma: "",
        expected_serial_number: [],
        line_comment: "",
        flex_field: [],
        // Add by Dev team for showing text
        order_line_text: "",
        showPartRet: "",
        showPartShip: "",
        showBuild: "",
        showSerial: "",
      },
      soHistory: true,
      revertToBackOrderDialog: false,
      forceAllocateOrderDialog: false,
      clearShippingAuditDialog: false,
      shipmentHoldConfirmDialog: false,
      shipmentHoldReasonDialog: false,
      shipmentHoldReason: "",
      salesOrderHistoryRecords: [],
      salesOrderHistoryItems: [],
      salesOrderHistoryDialog: false,
      salesOrderHistoryActionFilter: "All Actions",
      salesOrderHistoryEntityFilter: "All Entities",
      salesOrderHistoryUserFilter: "All Users",
      salesOrderHistorySearch: "",
      callLogDeleteDialog: false,
      callLogsData: [],
      callLogSubmitBtnName: "Submit",
      selectedCallLogId: 0,
      callLogViewOnly: true,
      headersSalesOrderHistory: [
        {
          text: "Action",
          align: "start",
          value: "Action",
          class: "primary customwhite--text",
        },
        { text: "Changed", value: "Changed", class: "primary customwhite--text" },
        { text: "Changed By", value: "ChangedBy", class: "primary customwhite--text" },
        { text: "Entity", value: "Entity", class: "primary customwhite--text" },
        { text: "Field", value: "Field", class: "primary customwhite--text" },
        { text: "Old Value", value: "OldValue", class: "primary customwhite--text" },
        { text: "New Value", value: "NewValue", class: "primary customwhite--text" },
      ],
      trackingCurrentStatus: "",
      trackingWaybillHistoryDialog: false,
      trackingWaybillHistoryItems: [],
      headersTrackingWaybillHistory: [
        { text: "Waybill", align: "center", value: "WayBill", class: "primary customwhite--text", sortable: false, width: "20%" },
        { text: "Date", align: "center", value: "Date", class: "primary customwhite--text", sortable: false, width: "20%" },
        { text: "Status", align: "center", value: "Status", class: "primary customwhite--text", sortable: false, width: "60%" },
      ],
      headerCallLogs: [
        {
          text: "Contact Date",
          align: "start",
          value: "ContactDateTime",
          class: "primary customwhite--text",
        },
        {
          text: "Recipient Name",
          value: "RecipientName",
          class: "primary customwhite--text",
        },
        {
          text: "Method",
          value: "Method",
          class: "primary customwhite--text",
        },
        {
          text: "Outcome",
          value: "Outcome",
          class: "primary customwhite--text",
        },
        {
          text: "Follow-up Date",
          value: "FollowupDate",
          class: "primary customwhite--text",
        },
        {
          text: "Actions",
          value: "actions",
          class: "primary customwhite--text",
        },
      ],
      labelDialog: false,
      labelDialogName: "",
      labelLink: "",
      labelType: "",
      labelZpl: "",
      labelRaw: "",
      labelHistoryDialog: false,
      labelHistoryDir: "",
      labelHistorySorecpId: 0,
      labelHistoryData: [],
      headersLabelHistory: [
        {
          text: "Waybill",
          align: "start",
          value: "waybill",
          class: "primary customwhite--text",
        },
        {
          text: "Shipped Date",
          value: "cdate",
          class: "primary customwhite--text",
        },
        {
          text: "Tech",
          value: "username",
          class: "primary customwhite--text",
        },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "").split("/")[0];
    //to Load Data
    let data = await AddFavourite.getParentPageAction(this.userId, this.route);
    let pagePermissions = data?.actionList;
    this.mainPage = data?.mainPage;
    this.favouriteList = data?.favouriteList;
    this.pageUrl = data?.pageUrl;
    this.subPage = data?.subPage;
    this.showAdd = data?.showAdd;
    this.subPageUrl = data?.subPageUrl;
    this.appPageName = data?.appPageName;
    //New BreadCrumb format COde DO NOT Remove IT
    let actionData = await AddFavourite.getParentPageAction(this.userId, this.subPageUrl);
    this.actionList = actionData?.actionList;
    pagePermissions.forEach((element) => {
      this.actionList.push(element);
    });
    // to load the Project Dropdown
    let LoaderDialog = {
      visible: true,
      title: "Please Wait...",
    };
    this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    this.salesOrderId = atob(this.$route.params.id);
    let salesOrderDetails = await salesOrderEditService.getSalesOrderDetails("get", this.userId, this.salesOrderId);
    // Assigning the values we get from API to the Form JSON we created
    this.salesOrderJson = JSON.parse(JSON.stringify(salesOrderDetails.Result[0]));
    this.convertTime();
    this.getSOCallLogs();
    this.getTrackingStatus();
    this.bookmark = Boolean(this.salesOrderJson.is_bookmark);
    this.showActionsList.push({
      Id: "SO-History",
      Icon: "mdi mdi-account-clock-outline",
      FriendlyName: "SO History",
    });
    if (this.actionSetter("ShipmentHold")) {
      this.showActionsList.push({
        Id: "SO-ShipmentHold",
        Icon: "mdi-truck-alert-outline",
        FriendlyName: "Shipment Hold",
      });
    }
    if (this.bookmark)
      this.showActionsList.push({
        Id: "SO-BookMark-Remove",
        Icon: "mdi mdi-bookmark-outline",
        FriendlyName: "Remove Bookmark",
      });
    else
      this.showActionsList.push({
        Id: "SO-BookMark",
        Icon: "mdi mdi-bookmark",
        FriendlyName: "Add Bookmark",
      });
    this.showDeleteWarningMessage = Boolean(this.salesOrderJson.enable_edit_so);
    //this.lineTypeData();
    this.validateLineType();
    this.returnSearchKey = this.salesOrderJson.return_address[0].rt_company;
    this.shipSearchKey = this.salesOrderJson.shipment_address[0]?.sh_company;
    //this.custSearchKey = this.salesOrderJson?.CustomerInfo[0]?.company;
    LoaderDialog.visible = false;
    this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    this.setActionFunction();
    this.outboundOrderLine();
    this.interval = setInterval(() => {
      this.resetFunction();
    }, 120000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEditing) {
      if (window.confirm("Leave without saving?")) {
        next();
      } else {
        return false;
      }
    }
    next();
  },
  computed: {
    isShippingHold() {
      const value = this.salesOrderJson?.is_shipping_hold;
      return value === true || value === 1 || String(value).toLowerCase() === "true";
    },
    computedDateFormattedMomentjs() {
      return this.salesOrderJson.ordered_date
        ? moment(String(this.salesOrderJson.ordered_date)).format("MM/DD/YYYY")
        : moment(String(new Date())).format("MM/DD/YYYY");
    },
    shipcomputeDateFormattedMomentjs() {
      return this.salesOrderJson.requested_ship_date ? moment(String(this.salesOrderJson.requested_ship_date)).format("MM/DD/YYYY") : "";
    },
    newHireComputedDateFormattedMomentjs() {
      return this.salesOrderJson.new_hire_date ? moment(this.salesOrderJson.new_hire_date).format("MM/DD/YYYY") : "";
    },
    createdDateFormatted() {
      return this.salesOrderJson?.cdate ? Utility.displayDateFormat(this.salesOrderJson.cdate) : Utility.displayDateFormat(new Date());
    },
    editedDateFormatted() {
      return this.salesOrderJson?.udate ? Utility.displayDateFormat(this.salesOrderJson.udate) : Utility.displayDateFormat(new Date());
    },
    hasSelectableRows() {
      return this.partialLineData.some((item) => item.is_selectable !== 0);
    },
    selectableRows() {
      return this.partialLineData.filter((item) => Number(item.is_selectable) !== 0);
    },
    allSelectableSelected() {
      const selected = this.selectedRows || [];
      return this.selectableRows.length > 0 && selected.length >= this.selectableRows.length;
    },
    someSelectableSelected() {
      const selected = this.selectedRows || [];
      return selected.length > 0 && !this.allSelectableSelected;
    },
    filteredCallLogs() {
      return this.callLogsData.filter((x) => !x.is_Deleted);
    },
    canEditCallLog() {
      return this.actionSetter("EditSalesOrder");
    },
    shippedHeadersFiltered() {
      return this.actionSetter("ViewShippingLabel")
        ? this.headersShipped
        : this.headersShipped.filter((header) => header.value !== "Outbound_Label" && header.value !== "Inbound_Label");
    },
    computedContactDateFormattedMomentjs() {
      return this.conDate
        ? moment(this.conDate, "YYYY-MM-DD").format("MM/DD/YYYY")
        : "";
    },
    computedContactTimeFormattedMomentjs() {
      return this.conTime
        ? moment(this.conTime, "HH:mm").format("hh:mm A")
        : "";
    },
    computedFollowupDateFormattedMomentjs() {
      return this.followDate ? moment(this.followDate).format("MM/DD/YYYY") : moment(new Date()).format("MM/DD/YYYY");
    },
    frameSrc() {
      return this.labelLink;
    },
    salesOrderHistoryActionOptions() {
      return ["All Actions", ...new Set(this.salesOrderHistoryRecords.map((item) => item.Action).filter(Boolean))];
    },
    salesOrderHistoryEntityOptions() {
      return ["All Entities", ...new Set(this.salesOrderHistoryRecords.map((item) => item.Entity).filter(Boolean))];
    },
    salesOrderHistoryUserOptions() {
      return ["All Users", ...new Set(this.salesOrderHistoryRecords.map((item) => item.ChangedBy).filter(Boolean))];
    },
    filteredSalesOrderHistoryRecords() {
      const search = this.salesOrderHistorySearch?.toLowerCase().trim();
      return this.salesOrderHistoryRecords.filter((item) => {
        const actionMatch = this.salesOrderHistoryActionFilter === "All Actions" || item.Action === this.salesOrderHistoryActionFilter;
        const entityMatch = this.salesOrderHistoryEntityFilter === "All Entities" || item.Entity === this.salesOrderHistoryEntityFilter;
        const userMatch = this.salesOrderHistoryUserFilter === "All Users" || item.ChangedBy === this.salesOrderHistoryUserFilter;
        const changeText = item.Changes.reduce((values, change) => {
          values.push(change.Field, change.OldValue, change.NewValue);
          return values;
        }, []);
        const searchText = [
          item.Action,
          item.Entity,
          item.ChangedBy,
          ...changeText,
        ].join(" ").toLowerCase();
        return actionMatch && entityMatch && userMatch && (!search || searchText.includes(search));
      });
    },
    groupedSalesOrderHistoryRecords() {
      return this.filteredSalesOrderHistoryRecords.reduce((groups, item) => {
        const label = item.Changed ? moment(item.Changed).format("MMM DD, YYYY").toUpperCase() : "NO DATE";
        let group = groups.find((entry) => entry.date === label);
        if (!group) {
          group = { date: label, records: [] };
          groups.push(group);
        }
        group.records.push(item);
        return groups;
      }, []);
    },
  },
  mounted() {},
  methods: {
    formatTimelineDate(date) {
      return date ? moment(date).format("MM/DD/YY") : "";
    },
    timelineInfo() {
      const timelineInfo = this.salesOrderJson?.timeline_info || [];
      return Array.isArray(timelineInfo) ? (timelineInfo[0] || {}) : (timelineInfo || {});
    },
    timelineStatusValue() {
      const timeline = this.timelineInfo();
      return this.normalizeTimelineStatus(timeline.TimelineStatus);
    },
    normalizeTimelineStatus(status) {
      const timelineStatus = String(status || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim()
        .toUpperCase();
      const compactStatus = timelineStatus.replace(/[\s-_]/g, "");
      if (compactStatus.includes("ONTIME")) return "ON-TIME";
      if (compactStatus.includes("MUSTSHIP")) return "MUST SHIP";
      if (compactStatus.includes("PASTDUE")) return "PAST DUE";
      return timelineStatus;
    },
    timelineStatusColorValue() {
      const timeline = this.timelineInfo();
      return timeline.TimelineColor || "";
    },
    timelineStatusBackgroundColor(backgroundColor) {
      const color = String(backgroundColor || "").trim();
      if (!color) return "#ECEFF1";
      const normalized = color.toLowerCase();
      const namedColors = {
        green: this.$vuetify.theme.dark ? "#A5D6A7" : "#2E7D32",
        red: this.$vuetify.theme.dark ? "#EF9A9A" : "#C62828",
        yellow: "#FFEB3B",
        orange: this.$vuetify.theme.dark ? "#FFCC80" : "#EF6C00",
        blue: this.$vuetify.theme.dark ? "#90CAF9" : "#1565C0",
        grey: this.$vuetify.theme.dark ? "#CFD8DC" : "#607D8B",
        gray: this.$vuetify.theme.dark ? "#CFD8DC" : "#607D8B",
      };
      if (namedColors[normalized]) return namedColors[normalized];
      const yellowValues = ["yellow", "#ffff00", "#ffc107", "#ffeb3b", "ffc107", "ffeb3b", "ffff00"];
      return yellowValues.includes(normalized) ? "#FFEB3B" : color;
    },
    timelineStatusTextColor(backgroundColor) {
      if (!backgroundColor) return "#263238";
      const normalized = String(backgroundColor).trim().toLowerCase();
      const yellowValues = ["yellow", "#ffff00", "#ffc107", "#ffeb3b", "ffc107", "ffeb3b", "ffff00"];
      if (yellowValues.includes(normalized)) return "#000000";
      let hex = String(backgroundColor).trim().replace("#", "");
      if (hex.length === 3) {
        hex = hex.split("").map((char) => char + char).join("");
      }
      if (!/^[0-9a-fA-F]{6}$/.test(hex)) return "#263238";
      const red = parseInt(hex.substring(0, 2), 16);
      const green = parseInt(hex.substring(2, 4), 16);
      const blue = parseInt(hex.substring(4, 6), 16);
      const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;
      return luminance > 0.6 ? "#263238" : "#FFFFFF";
    },
    formatSalesOrderHistoryTime(date) {
      return date ? moment(date).format("h:mm:ss A") : "";
    },
    displayHistoryValue(value) {
      return value === null || value === undefined || String(value).trim() === "" ? "-" : value;
    },
    normalizeSalesOrderHistory(historyData) {
      const historyItems = historyData.ActionLogInfo || historyData.Data || (Array.isArray(historyData) ? historyData : []);
      return historyItems.map((item, index) => ({
        _idx: item.ChangeGroup || index,
        ChangeGroup: item.ChangeGroup,
        Changed: item.Changed || item.Logged,
        ChangedBy: item.ChangedBy || item.User || "",
        Action: item.Action || "",
        Entity: item.Entity || "",
        RecordCount: item.RecordCount,
        expanded: false,
        Changes: item.Changes?.length
          ? item.Changes
          : [{
            Field: item.Field || "",
            OldValue: item.OldValue || "",
            NewValue: item.NewValue || "",
          }],
      }));
    },
    buildSalesOrderHistoryRows(records) {
      return records.reduce((items, obj, groupIndex) => {
        const changes = obj.Changes?.length ? obj.Changes : [{}];
        changes.forEach((change, changeIndex) => items.push({
          _idx: `${groupIndex}-${changeIndex}`,
          ChangeGroup: obj.ChangeGroup,
          Changed: obj.Changed ? Utility.displayDateFormat(obj.Changed) : "",
          ChangedBy: obj.ChangedBy,
          Action: obj.Action,
          Entity: obj.Entity,
          RecordCount: obj.RecordCount,
          Field: change.Field || "",
          OldValue: change.OldValue || "",
          NewValue: change.NewValue || "",
        }));
        return items;
      }, []);
    },
    getHistoryLineDetails(value) {
      if (!value) return [];
      return String(value)
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean)
        .map((part) => {
          const splitIndex = part.indexOf("=");
          if (splitIndex === -1) return { label: "", value: part };
          return {
            label: part.substring(0, splitIndex).trim(),
            value: part.substring(splitIndex + 1).trim(),
          };
        });
    },
    historyChangeTitle(record) {
      const change = record.Changes?.[0] || {};
      const lineMatch = String(change.NewValue || "").match(/Line#(\d+)/);
      const lineLabel = lineMatch ? `Line #${lineMatch[1]}` : "Line";
      if (record.Action === "DELETE" && change.Field === "Line Deleted") return `${lineLabel} deleted`;
      if (record.Action === "ADD" && change.Field === "Line Added") return `${lineLabel} added`;
      if (record.Changes?.length > 1) return `${record.Changes.length} fields changed`;
      return change.Field || record.Entity;
    },
    isLineSummary(record) {
      const field = record.Changes?.[0]?.Field;
      return record.Changes?.length === 1 && (field === "Line Deleted" || field === "Line Added");
    },
    async partialShipmentLineItem() {
      this.manualSelected = false;
      this.automaticSelected = false;
      let data = await salesOrderEditService.getSalesOrderPartialShipLineItem("get", this.userId, this.salesOrderId);
      this.partialLineData = [];
      if (data.message !== "NA") {
        this.showPartialShip = true;
        this.partialLineData = data?.order_list;
      }
    },
    manualMethod() {
      this.manualSelected = true;
      this.automaticSelected = false;
      this.disableManual = false;
      this.disableAutomatic = true;
      this.disableSubmit = false;
    },
    automaticMethod() {
      this.manualSelected = false;
      this.automaticSelected = true;
      this.disableManual = true;
      this.disableAutomatic = false;
      this.disableSubmit = false;
    },
    closeDialog() {
      this.manualSelected = false;
      this.automaticSelected = false;
      this.showPartialShip = false;
      this.disableManual = false;
      this.disableAutomatic = false;
      this.disableSubmit = true;
      this.partialLineData = [];
      this.resetFunction();
    },
    async submitPartialShipment() {
      const totalCount = this.partialLineData.length;
      const selectableCount = this.partialLineData.filter((row) => Number(row.is_selectable) === 1).length;
      const allSelectable = totalCount > 0 && selectableCount === totalCount;
      if (this.manualSelected) {
        if (allSelectable) {
          const selectedCount = this.selectedRows ? this.selectedRows.length : 0;
          if (selectedCount === totalCount) {
            let Alert = {
              type: "error",
              isShow: true,
              message: "Partial shipment is not applicable as all line items are available for full shipment.",
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            return;
          }
        }
        this.salesOrderJson.isAuto = false;
        if (this.selectedRows !== undefined && this.selectedRows !== "" && this.selectedRows !== null) {
          const selectedIds = this.selectedRows.map((row) => row.line_id);
          const updatedArray = this.partialLineData.map((row) => ({
            ...row,
            isChecked: selectedIds.includes(row.line_id),
          }));
          this.salesOrderJson.order_line = updatedArray;
          let partialShipmentJSON = this.buildRequiredJson(this.salesOrderJson);
          let obj = {
            UserId: parseInt(this.userId),
            json: JSON.stringify(partialShipmentJSON),
          };
          let LoaderDialog = {
            visible: true,
            title: "Please Wait...",
          };
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          this.axios
            .post("/so/so_partialship_create", obj)
            .then((response) => {
              if (response.status == 200 || response.status == 204) {
                let data = JSON.parse(response.data.body.message);
                this.treePartialShipmentData = [];
                this.openPartialShipmentData = [];
                this.buildTree(data?.Result);
                this.orderRedirectDialog = true;
                let Alert = {
                  type: "success",
                  isShow: true,
                  message: "Partial Shipment is done",
                };
                this.$store.commit("ConfigModule/Alert", Alert);
                this.closeDialog();
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              } else {
                LoaderDialog.visible = false;
                this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
                let Alert = {
                  type: "error",
                  isShow: true,
                  message: response.data.message,
                };
                this.$store.commit("ConfigModule/Alert", Alert);
              }
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            })
            .catch((error) => {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: Utility.apiError(error),
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.errorMessage = error.message;
            });
        } else {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Select atleast one Line Item to proceed",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
      }
      if (this.automaticSelected) {
        if (allSelectable) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Partial shipment is not applicable as all line items are available for full shipment.",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          return;
        }
        this.salesOrderJson.isAuto = true;
        const updatedArray = this.partialLineData.map((row) => ({
          ...row,
          isChecked: true,
        }));
        this.salesOrderJson.order_line = updatedArray;
        let partialShipmentJSON = this.buildRequiredJson(this.salesOrderJson);
        let obj = {
          UserId: parseInt(this.userId),
          json: JSON.stringify(partialShipmentJSON),
        };
        let LoaderDialog = {
          visible: true,
          title: "Please Wait...",
        };
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        this.axios
          .post("/so/so_partialship_create", obj)
          .then((response) => {
            if (response.status == 200 || response.status == 204) {
              let data = JSON.parse(response.data.body.message);
              this.treePartialShipmentData = [];
              this.openPartialShipmentData = [];
              this.buildTree(data?.Result);
              this.orderRedirectDialog = true;
              let Alert = {
                type: "success",
                isShow: true,
                message: "Partial Shipment is done",
              };
              this.$store.commit("ConfigModule/Alert", Alert);
              this.closeDialog();
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            } else {
              LoaderDialog.visible = false;
              this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
              let Alert = {
                type: "error",
                isShow: true,
                message: response.data.message,
              };
              this.$store.commit("ConfigModule/Alert", Alert);
            }
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          })
          .catch((error) => {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: Utility.apiError(error),
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.errorMessage = error.message;
          });
      }
    },
    async partialShipmentHistory() {
      let data = await salesOrderEditService.getSalesOrderPartialShipHistory("get", this.salesOrderJson.so_id, this.userId);
      this.partialShipHistoryData = [];
      if (data.message !== "NA") {
        this.partialShipHistoryData = this.buildOrderTreeWithLines(data);
        this.partialShipHistoryDialog = true;
      }
    },
    handleNodeClick(orderId) {
      this.$router.push(`/sales-order-details/${btoa(orderId.toString())}`);
    },
    buildOrderTreeWithLines(data) {
      if (!Array.isArray(data) || !data.length) return [];
      const map = {};
      const roots = [];
      data.forEach((item) => {
        const childLines = item.line_history?.map((l) => l.child_line_no) || [];
        map[item.OrderId] = {
          ...item,
          displayLabel: `${item.OrderNo} (${childLines.join(", ")})`,
          children: [],
          expanded: true,
        };
      });
      data.forEach((item) => {
        if (map[item.ParentId]) {
          map[item.ParentId].children.push(map[item.OrderId]);
        } else {
          roots.push(map[item.OrderId]);
        }
      });
      return roots;
    },
    buildTree(orders) {
      if (!Array.isArray(orders)) {
        this.treePartialShipmentData = [];
        this.openPartialShipmentData = [];
        return;
      }
      const tree = orders.map((order) => {
        return {
          id: order.new_order_id,
          new_sono: order.new_sono,
          new_order_id: order.new_order_id,
          isParent: true,
          children: Array.isArray(order.line_numbers)
            ? order.line_numbers.map((ln, index) => ({
                id: order.new_order_id + "-" + index,
                name: "Line Number: " + ln.line_num,
                isParent: false,
              }))
            : [],
        };
      });
      this.treePartialShipmentData = tree;
      // open all parents
      this.openPartialShipmentData = tree.map((item) => item.id);
    },
    buildRequiredJson(salesOrderJson) {
      return {
        so_id: salesOrderJson.so_id != null ? salesOrderJson.so_id.toString() : "",
        isAuto: salesOrderJson.isAuto ? 1 : 0,
        proj_id: salesOrderJson.proj_id,
        bu_id: salesOrderJson.bu_id,
        order_line: Array.isArray(salesOrderJson.order_line)
          ? salesOrderJson.order_line.map(function (line) {
              return {
                sequence_number: line.sequence_number,
                order_line_type: line.order_line_type,
                line_number: line.line_number,
                line_id: line.line_id,
                is_Checked: line.isChecked === true,
                flex_field: [],
              };
            })
          : [],
      };
    },
    setActionFunction() {
      this.showActionsList = this.showActionsList.filter((item) => item.Id !== "SO-Edit");
      if (this.actionSetter("EditSalesOrder"))
        this.showActionsList.push({
          Id: "SO-Edit",
          Icon: "mdi-pencil",
          FriendlyName: "SO Edit",
        });
    },
    onClickShipmentHoldConfirm() {
      this.shipmentHoldConfirmDialog = true;
    },
    onClickShipmentHoldReasonDialog() {
      this.$refs.shipmentHoldReasonForm?.resetValidation();
      this.shipmentHoldReason = "";
      this.shipmentHoldConfirmDialog = false;
      this.shipmentHoldReasonDialog = true;
    },
    async submitShipmentHoldRelease() {
      this.shipmentHoldConfirmDialog = false;
      this.shipmentHoldReasonDialog = false;
      let shipmentHoldObj = {
        so_id: this.salesOrderId,
        hold_reason: "",
        UserId: this.userId,
      };
      let resp = await salesOrderEditService.postSoShippingHold(
        "post",
        shipmentHoldObj,
        true
      );

      if (resp?.Result) {
        this.salesOrderJson.message = resp.Result[0].displaymessage;
        this.resetFunction();
      }
    },
    submitShipmentHoldReason() {
      // Submit behavior will be defined when the shipping-hold endpoint is ready.
    },
    async getCommentData() {
      let commentData = this.salesOrderJson?.comments ? JSON.parse(this.salesOrderJson?.comments).CommentsInfo : [];
      commentData?.forEach((element) => {
        element.name = element.username;
        element.date = Utility.displayDateFormat(element.modified_date);
        element.showEdit = false;
        element.showDelete = false;
      });
      this.commentList = commentData;
    },
    // Action
    actionSetter(action) {
      if (this.actionList !== undefined && this.actionList !== null && this.actionList !== "") {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter.length >= 1 ? true : false;
      } else return false;
    },
    //Sales Order History button click event
    async salesOrderHistory() {
      this.salesOrderHistoryRecords = [];
      this.salesOrderHistoryItems = [];
      this.salesOrderHistoryDialog = true;
      try {
        let historyData = await salesService.getSalesOrderChangeLog(this.salesOrderId, this.userId);
        if (historyData !== null && historyData !== undefined && historyData?.message !== "NA") {
          const records = this.normalizeSalesOrderHistory(historyData);
          this.salesOrderHistoryRecords = records;
          this.salesOrderHistoryItems = this.buildSalesOrderHistoryRows(records);
        }
      } finally {
        this.salesOrderHistoryDialog = true;
      }
    },
    // Fetch the current waybill tracking status shown below Shipped Date
    async getTrackingStatus() {
      let data = await salesOrderEditService.getSoTrackingWaybills("get", this.salesOrderId);
      this.trackingCurrentStatus = data?.Data?.[0]?.Current_Status || "";
    },
    // Waybill tracking Status link click event
    async onClickTrackingStatus() {
      let data = await salesOrderEditService.getSoTrackingWaybillHistory("get", this.salesOrderId);
      this.trackingWaybillHistoryItems = (data?.Data || []).map((item, index) => ({
        ...item,
        Date: item.Date ? Utility.displayDateFormat(item.Date) : "",
        _idx: index,
      }));
      this.trackingWaybillHistoryDialog = true;
    },
    // Line type API call
    async lineTypeData(item = "") {
      let LineTypeData = await salesOrderEditService.getOrderTypeData(
        "get",
        this.userId,
        this.salesOrderJson.proj_id,
        this.salesOrderId,
        (this.isAddLine = false),
      );
      if (LineTypeData?.LineTypeInfo) {
        this.lineTypeList = LineTypeData.LineTypeInfo.map((x) => ({
          so_type_id: x.sotype_id,
          so_desc: x.so_desc,
          so_type: x.so_type,
          to_ship: x.to_ship,
          to_return: x.to_return,
        }));
      }
      let lineItemData = await salesOrderEditService.getLineItemData("get", this.userId, item.line_id);
      this.temp_order_line = JSON.parse(JSON.stringify(lineItemData.LineItem[0]));
      this.showPartsItem = true;
      this.disableLine = true;
      let obj = this.lineTypeList.filter((x) => x.so_type_id == item.order_line_type);
      this.showPartShip = obj[0]?.to_ship == 1 ? true : false;
      this.showPartRet = obj[0]?.to_return == 1 ? true : false;
      this.showFlex = true;
      this.temp_order_line.order_line_text = obj[0]?.so_desc;
      this.temp_order_line.showPartShip = this.showPartShip;
      this.temp_order_line.showPartRet = this.showPartRet;
      this.showFlex = true;
      this.edit_line_num = item.line_number;
      this.partShipSearchKey = this.temp_order_line.sh_part_number;
      this.shipPartName = this.temp_order_line.sh_part_number;
      this.shipPartDesc = this.temp_order_line.sh_part_description;
      this.partReturnSearchKey = this.temp_order_line.return_part_number;
      this.returnPartNum = this.temp_order_line.return_part_number;
      this.returnPartDesc = this.temp_order_line.return_part_description;
      this.temp_order_line.sh_from_warehouse_id = this.temp_order_line.sh_from_warehouse_id + "_" + this.temp_order_line.sh_from_inventory_bucket;
      this.temp_order_line.return_to_warehouse_id =
        this.temp_order_line.return_to_warehouse_id + "_" + this.temp_order_line.return_to_inventory_bucket;
      //Ship Object
      let shipWareObj = {
        part_num: this.temp_order_line.sh_part_number ? this.temp_order_line.sh_part_number : this.temp_order_line.return_part_number,
        order_type: this.salesOrderJson.order_type,
        sotype_key: this.temp_order_line.order_line_type,
        order_bu_key: this.salesOrderJson.bu_id,
        line_id: 0, //Do not Delete
        so_key: this.salesOrderJson.so_id, //DO not Delete
        UserId: this.userId,
      };
      let shipWarehouseList = await salesOrderEditService.postShipWareData("post", shipWareObj);
      if (shipWarehouseList?.ShipFromWare) {
        this.shipWareList = shipWarehouseList.ShipFromWare.map((x) => ({
          ware: x.ware,
          ware_id: x.ware_id + "_" + x.bucket,
          bucket: x.bucket,
          from_warebuck: x.from_warebuck,
          show_text: x.show_text,
        }));

        this.stockMessage = this.shipWareList[0].show_text;
        this.fix_price = shipWarehouseList.ShipFromWare[0]?.fix_price || 0;
        this.last_price = shipWarehouseList.ShipFromWare[0]?.last_price || 0;
        this.avg_cost = shipWarehouseList.ShipFromWare[0]?.avg_cost || 0;
      }

      if (this.showPartRet && this.temp_order_line?.return_part_number) {
        let returnObj = {
          part_num: this.temp_order_line.return_part_number,
          order_type: this.salesOrderJson.order_type,
          sotype_key: this.temp_order_line.order_line_type,
          order_bu_key: this.salesOrderJson.bu_id,
          line_id: 0, //Do not Delete
          so_key: this.salesOrderJson.so_id, //DO not Delete
          UserId: this.userId,
        };
        let returnWareData = await salesOrderEditService.postShipWareData("post", returnObj);
        if (returnWareData?.ReturnToWare != "") {
          this.returnWareList = shipWarehouseList.ReturnToWare.map((x) => ({
            ware: x.ware,
            ware_id: x.ware_id + "_" + x.bucket,
            bucket: x.bucket,
            into_warebuck: x.into_warebuck,
          }));
        }
      }
    },
    // Reset Function
    async resetFunction() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.getCommentData();
      this.getInboundGridData();
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.salesOrderDetails = await salesOrderEditService.getSalesOrderDetails("get", this.userId, this.salesOrderId);
      // Assigning the values we get from API to the Form JSON we
      this.salesOrderJson = JSON.parse(JSON.stringify(this.salesOrderDetails.Result[0]));
      this.convertTime();
      this.setActionFunction();
      LoaderDialog.visible = false;
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //View Line Item Details
    async lineItemsView(item) {
      if (item.order_line_type == 1) {
        this.lineItemPanel = [0];
      } else if (item.order_line_type == 8) {
        this.lineItemPanel = [1];
      } else {
        this.lineItemPanel = [0, 1];
      }
      this.temp_order_line.flex_field = [];
      this.showPartDetails = true;
      this.showPartsItem = true;
      this.showLineDelete = true;
      this.lineTypeData(item);
      let warrentyData = await salesOrderEditService.getWarrentyData("get", this.userId);
      if (warrentyData != "") {
        this.warrentyList = warrentyData.WarrantyData;
      }
    },
    validateLineType() {
      //User to find Unique items in an array;
      let lineItemUsedObj = this.salesOrderJson.order_list.reduce((acc, cur) => {
        acc[cur.order_line_type] = true;
        return acc;
      }, {});
      let lineTypeListObj = this.lineTypeList.reduce((acc, cur) => {
        acc[cur.so_type_id] = cur;
        return acc;
      }, {});
      Object.keys(lineTypeListObj).forEach((key) => {
        if (lineItemUsedObj[key]) {
          this.shippingReq = this.shippingReq || Boolean(lineTypeListObj[key].to_ship);
          this.returnReq = this.returnReq || !!lineTypeListObj[key].to_return;
        }
      });
    },
    // To View hyperLinks
    async onClickedHyperLink(value, item) {
      if (value === "Picked") {
        let pickedData = await salesOrderEditService.getSalesOrderPickedData("get", this.salesOrderId, item.line_number, this.userId);
        if (pickedData?.Data) {
          this.showLinkDialog = true;
          this.selectedLink = value;
          this.pickedDataList = pickedData.Data;
          this.pickedDataList.forEach((element) => {
            element.Picked = Utility.displayDateFormat(element.Picked);
          });
        }
      } else if (value === "Received") {
        let receivedData = await salesOrderEditService.getSalesOrderReceivedData("get", this.salesOrderId, item.line_number, this.userId);
        if (receivedData?.Data) {
          this.showLinkDialog = true;
          this.selectedLink = value;
          this.receivedDataList = receivedData.Data;
          this.receivedDataList?.forEach((element) => {
            element.Date = Utility.displayDateFormat(element.Date);
          });
        }
      } else if (value === "Shipped") {
        let shippedData = await salesOrderEditService.getSalesOrderShippedData("get", this.salesOrderId, item.line_number, this.userId);
        if (shippedData?.Data) {
          this.showLinkDialog = true;
          this.selectedLink = value;
          this.shippedDataList = shippedData.Data;
          this.shippedDataList.forEach((element) => {
            element.Shipped = Utility.displayDateFormat(element.Shipped);
          });
        }
      }
    },
    redirectPage() {
      this.$router.push(`/sales-order-edit/${btoa(this.salesOrderId.toString())}`);
    },
    onClickPartialOrderNo(item) {
      this.orderRedirectDialog = false;
      this.treePartialShipmentData = [];
      this.openPartialShipmentData = [];
      this.$router.push(`/sales-order-details/${btoa(item.new_order_id.toString())}`);
    },
    closeLinkDialog() {
      this.showLinkDialog = false;
      this.selectedLink = "";
      this.pickedDataList = [];
      this.receivedDataList = [];
      this.shippedDataList = [];
    },
    //Add BookMark
    async addBookmark() {
      let resp = await salesOrderEditService.addBookMark("get", this.userId, this.salesOrderId, true);
      if (resp?.Result) {
        this.bookmark = true;
        this.showActionsList = this.showActionsList.filter((item) => item.Id != "SO-BookMark");
        this.showActionsList.unshift({
          Id: "SO-BookMark-Remove",
          Icon: "mdi mdi-bookmark-outline",
          FriendlyName: "Remove Bookmark",
        });
      } else {
        this.bookmark = false;
        bus.$emit("bookmark", this.bookmark);
      }
    },
    //remove BookMark
    async removeBookmark() {
      let resp = await salesService.getDeleteBookmarkSO("get", this.userId, this.salesOrderId, true);
      if (resp?.Result) {
        this.bookmark = false;
        this.showActionsList = this.showActionsList.filter((item) => item.Id != "SO-BookMark-Remove");
        this.showActionsList.unshift({
          Id: "SO-BookMark",
          Icon: "mdi mdi-bookmark",
          FriendlyName: "Add Bookmark",
        });
      } else {
        this.bookmark = true;
        bus.$emit("bookmark", this.bookmark);
      }
    },
    // get Inbound grid Data
    async getInboundGridData() {
      let inboundData = this.salesOrderJson?.inbound ? JSON.parse(this.salesOrderJson?.inbound).Inbound : [];
      inboundData?.forEach((element) => {
        element.created_date = Utility.displayDateFormat(element.created_date);
      });
      this.inboundDataList = inboundData;
    },
    // Get outbound Grid Data
    async getOutboundGridData() {
      let outboundData = this.salesOrderJson?.outbound ? JSON.parse(this.salesOrderJson?.outbound).Outbound : [];
      outboundData?.forEach((element) => {
        element.created_date = Utility.displayDateFormat(element?.created_date);
        element.retrieved = element?.retrieved ? Utility.displayDateFormat(element?.retrieved) : "";
      });
      this.outboundDataList = outboundData;
    },

    //on click of popup messages for outbound
    async getMessageData(msgId) {
      this.onClickDetailsView("outboundLog", msgId);
    },
    //display outbound pupup message
    onClickDetailsView(text, item) {
      this.showDialogDetailsBox = true;
      if (text == "InboundJSON") {
        this.dialogBoxHeader = "View Inbound Request JSON";
        this.displayData = item.request_json;
      } else if (text == "InboundXML") {
        this.dialogBoxHeader = "View Inbound Request XML";
        this.displayData = item.request_xml.replaceAll(">", ">\n");
      } else if (text == "OutboundXML") {
        this.dialogBoxHeader = "View Outbound Request XML";
        this.displayData = item.replaceAll(">", ">\n");
      } else if (text == "OutboundJSON") {
        this.dialogBoxHeader = "View Outbound Request JSON";
        this.displayData = item;
      } else if (text == "outboundLog") {
        this.dialogBoxHeader = "View Outbound Response";
        this.showOutboundLog = true;
        this.outboundData.push(item);
      }
    },
    // addOutbound in List
    outboundOrderLine() {
      this.salesOrderJson.order_list.forEach((element) => {
        this.lineTypeList.forEach((ele) => {
          if (ele.so_type_id == element.order_line_type) {
            element["outboundPresent"] = ele.to_ship;
          }
        });
      });
    },
    convertTime() {
      this.salesOrderJson?.comments ? (JSON.parse(this.salesOrderJson?.comments)?.CommentsInfo?.length > 0 ? this.getCommentData() : "") : "";
      this.salesOrderJson?.inbound ? (JSON.parse(this.salesOrderJson?.inbound)?.Inbound?.length > 0 ? this.getInboundGridData() : "") : "";
      this.salesOrderJson?.outbound ? (JSON.parse(this.salesOrderJson?.outbound)?.Outbound.length > 0 ? this.getOutboundGridData() : "") : "";
      let timeZoneTime = Utility.getTimeFromLocalToTimeZone();
      this.salesOrderJson.cdate = this.salesOrderJson?.cdate
        ? Utility.displayDateFormat(this.salesOrderJson.cdate)
        : Utility.displayDateFormat(new Date());
      this.salesOrderJson.udate = this.salesOrderJson?.udate
        ? Utility.displayDateFormat(this.salesOrderJson.udate)
        : Utility.displayDateFormat(new Date());

      this.salesOrderJson.ordered_date = this.salesOrderJson?.ordered_date
        ? Utility.inputDateFormat(this.computedDateFormattedMomentjs, timeZoneTime, false)
        : Utility.inputDateFormat(new Date(), timeZoneTime, false);
      if (this.salesOrderJson.new_hire_date == "1900-01-01T00:00:00" || !this.salesOrderJson.new_hire_date) this.salesOrderJson.new_hire_date = "";
      else {
        this.salesOrderJson.new_hire_date = Utility.inputDateFormat(this.newHireComputedDateFormattedMomentjs, timeZoneTime, false);
      }
      if (this.salesOrderJson.requested_ship_date == "1900-01-01T00:00:00" || !this.salesOrderJson?.requested_ship_date) {
        this.salesOrderJson.requested_ship_date = "";
      } else {
        this.salesOrderJson.requested_ship_date = Utility.inputDateFormat(this.shipcomputeDateFormattedMomentjs, timeZoneTime, false);
      }
      if (this.salesOrderJson?.last_receipt_date == "1900-01-01T00:00:00" || !this.salesOrderJson?.last_receipt_date) {
        this.salesOrderJson.last_receipt_date = "";
      } else {
        this.salesOrderJson.last_receipt_date = Utility.displayDateFormat(this.salesOrderJson?.last_receipt_date);
      }
      if (this.salesOrderJson?.last_shipped_date == "1900-01-01T00:00:00" || !this.salesOrderJson?.last_shipped_date) {
        this.salesOrderJson.last_shipped_date = "";
      } else {
        this.salesOrderJson.last_shipped_date = this.salesOrderJson?.last_shipped_date
          ? Utility.displayDateFormat(this.salesOrderJson?.last_shipped_date)
          : "";
      }
    },
    async printSalesOrderPDF(data) {
      var LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      await this.$nextTick();
      const fmt = (d) => (d ? moment(d).format("MM/DD/YYYY") : "");
      const order = {
        ...data,
        cdate: fmt(data.cdate),
        udate: fmt(data.udate),
        requested_ship_date: fmt(data.requested_ship_date),
        ordered_date: fmt(data.ordered_date),
      };
      const ship = data.shipment_address?.[0] || {};
      const ret = data.return_address?.[0] || {};
      const lines = data.order_list || [];
      const label = (t) => `<span style="font-weight:bold;color:#666666">${t}:</span>`;
      const value = (v) => `<span style="color:#222222">${v || ""}</span>`;
      const value2 = (v) => `<span style="color:#222222">${v ?? ""}</span>`;
      const html = `
      <div style="
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
        color: #222222;
        padding: 15px;
      ">
      <table width="100%" cellpadding="6" cellspacing="0">
      <tr>
        <td width="33%" valign="top">
          ${label("Sales Order")}<br>${value(order.order_number)}<br><br>
          ${label("RMA Number")}<br>${value(order.rma)}
        </td>
        <td width="33%" valign="top">
          ${label("Purchase Order")}<br>${value(order.order_number)}<br><br>
          ${label("Order Number")}<br>${value(order.customer_order_number)}
        </td>
        <td width="33%" valign="top" align="right">
          <img
            src="${ucsLogo}"
            style="
              width:160px;
              height:auto;
              max-height:60px;
              object-fit:contain;
            "
          />
        </td>
      </tr>
      </table>
      <table width="100%" cellpadding="6" cellspacing="0">
      <tr>
        <td width="33%" valign="top" style="padding-top:10px;">
          ${label("Order Type")}<br>${value(order.order_type_id)}
        </td>
        <td width="33%" valign="top" style="padding-top:10px;">
          ${label("Order Date")}<br>${value(order.ordered_date)}
        </td>
        <td width="33%" valign="top" style="padding-top:10px;">
          ${label("Required Date")}<br>${value(order.requested_ship_date)}
        </td>
      </tr>
      </table>
      <table width="100%" cellpadding="6" cellspacing="0">
      <tr>
      <td width="33%" valign="top" style="padding-top:10px;">
        ${label("Ship To Company")}<br>
        ${value(ship.sh_company)}<br>
        ${value(ship.sh_address1)}<br>
        ${ship.sh_address2 ? value(ship.sh_address2) + "<br>" : ""}
        ${value(ship.sh_city)}, ${value(ship.sh_state)} ${value(ship.sh_zip)}
      </td>
      <td width="33%" valign="top" style="padding-top:10px;">
        ${label("Ship To Contact")}<br>
        ${value(`${ship.sh_first || ""} ${ship.sh_last || ""}`)}<br>
        ${value(ship.sh_phone1)}<br>
        ${value(ship.sh_email)}
      </td>
      <td width="33%" valign="top" style="padding-top:10px;">
        ${label("Shipper Company")}<br>
        ${value(ret.rt_company)}<br>
        ${value(ret.rt_address1)}<br>
        ${value(ret.rt_city)}, ${value(ret.rt_state)} ${value(ret.rt_zip)}
      </td>
      </tr>
      </table>
      <div style="border-top:1px solid #cccccc;margin:18px 0"></div>
      <table width="100%" cellpadding="6" cellspacing="0">
      <tr style="border-bottom:0.5px solid #919191;font-weight:bold;color:#666666">
        <td width="8%">Line</td>
        <td width="35%">Part Details</td>
        <td width="7%">Order</td>
        <td width="7%">Open</td>
        <td width="7%">Rcvd</td>
        <td width="7%">Shpd</td>
        <td width="7%">Price</td>
        <td width="10%">Ext. Price</td>
        <td width="12%">Warehouse</td>
      </tr>
      ${lines
        .map(
          (l) => `
      <tr style="border-bottom:1px solid #e0e0e0">
        <td valign="top">
          ${value(l.sequence_number)}<br>
          <span style="color:#666666">${l.order_line_text}</span>
        </td>
        <td valign="top">
          <b>${value(l.sh_part_number)}</b><br>
          ${value(l.sh_part_description)}
        </td>
        <td valign="top">${value(l.quantity)}</td>
        <td valign="top">${value(l.Open_Shipments)}</td>
        <td valign="top">${value(l.Rcvd)}</td>
        <td valign="top">${value(l.Shipped)}</td>
        <td valign="top">${value2(l.price)}</td>
        <td valign="top">${value2(l.extended_price)}</td>
        <td valign="top">
          ${value(l.sh_from_warehouse)}<br>
          ${value(l.sh_from_inventory_bucket)}
        </td>
      </tr>
      `,
        )
        .join("")}
      </table>
      <table width="100%" cellpadding="6" cellspacing="0">
        <tr>
          <td width="8%" style="font-weight:bold;color:#666666">Total</td>
          <td width="35%"></td>
          <td width="7%"></td>
          <td width="7%"></td>
          <td width="7%"></td>
          <td width="7%"></td>
          <td width="7%"></td>
          <td width="10%">${value2(order.summary?.total_price)}</td>
          <td width="12%"></td>
        </tr>
      </table>
      <div style="margin-top:20px">
        ${label("Comments / Notes")}<br>
        ${value(order.so_notes)}
      </div>
      </div>
      `;
      const el = document.createElement("div");
      el.innerHTML = html;
      document.body.appendChild(el);
      try {
        await html2pdf()
          .set({
            filename:
              order.order_number + "_" + new Date().toISOString().replace("T", "_").replace("Z", "").replace(".", "").replaceAll("-", "_") + ".pdf",
            margin: 10,
            image: { type: "jpeg", quality: 1 },
            html2canvas: { scale: 2, backgroundColor: "#ffffff" },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
            pagebreak: { mode: ["css", "legacy"] },
          })
          .from(el)
          .save();
      } finally {
        document.body.removeChild(el);
        LoaderDialog.visible = false;
        this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      }
    },
    refreshPartialShip() {
      this.disableSubmit = true;
      this.manualSelected = false;
      this.automaticSelected = false;
    },
    closeRedirectDialog() {
      this.orderRedirectDialog = false;
      this.treePartialShipmentData = [];
      this.openPartialShipmentData = [];
    },
    selectAllToggle(value) {
      if (value) {
        this.selectedRows = this.partialLineData.filter((row) => Number(row.is_selectable) !== 0);
      } else {
        this.selectedRows = [];
      }
    },
    soRevertToBackorderClicked() {
      if (this.isShippingHold) return;
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        UserId: parseInt(this.userId),
        so_id: parseInt(this.salesOrderJson.so_id),
      };
      this.axios
        .post("/so/so_revert_to_backorder", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.resetFunction();
            this.revertToBackOrderDialog = false;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
          this.revertToBackOrderDialog = false;
          this.forceAllocateOrderDialog = false;
          this.clearShippingAuditDialog = false;
        });
    },
    forceAllocateOrderClicked() {
      if (this.isShippingHold) return;
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        UserId: parseInt(this.userId),
        so_id: parseInt(this.salesOrderJson.so_id),
      };
      this.axios
        .post("/so/so_force_allocate_order", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.resetFunction();
            this.forceAllocateOrderDialog = false;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
          this.revertToBackOrderDialog = false;
          this.forceAllocateOrderDialog = false;
          this.clearShippingAuditDialog = false;
        });
    },
    clearShippingAuditClicked() {
      if (this.isShippingHold) return;
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        UserId: parseInt(this.userId),
        so_id: parseInt(this.salesOrderJson.so_id),
      };
      this.axios
        .post("/so/so_clear_shipping_audit", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let Alert = {
              type: "success",
              isShow: true,
              message: response.data.body.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.resetFunction();
            this.clearShippingAuditDialog = false;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
          this.revertToBackOrderDialog = false;
          this.forceAllocateOrderDialog = false;
          this.clearShippingAuditDialog = false;
        });
    },
    soCallLogsDialogCancel() {
      this.followDate = new Date(new Date().getTime()).toISOString().split("T")[0];
      this.conDate = new Date(new Date().getTime()).toISOString().split("T")[0];
      this.conTime = moment().format("HH:mm");
      this.contactDate = false;
      this.contactTime = false;
      this.followupDate = false;
      this.recipientName = "";
      this.method = "";
      this.outcome = "";
      this.notes = "";
      this.nextAction = "";
      this.soCallLogsDialog = false;
      this.callLogViewOnly = true;
      this.$refs.soCallLogForm.resetValidation();
    },
    async getSOCallLogs() {
      let obj = {
        Pass: 4,
        somast_callslog_id: 0,
        so_key: this.salesOrderJson.so_id,
        ContactDateTime: "2026-05-26T07:33:59.210Z",
        RecipientName: "",
        Method: "",
        Outcome: "",
        Notes: "",
        NextAction: "",
        FollowupDate: "2026-05-26T07:33:59.210Z",
        Createdby: 0,
        Modifiedby: 0,
      };
      let data = await salesService.salesOrderCallLogs("post", obj, false);
      const newArr = data.map((obj) => {
        return {
          ...obj,
          ContactDateTime: obj.ContactDateTime !== undefined ? Utility.displayDateFormat(obj.ContactDateTime) : "",
          FollowupDate: obj.FollowupDate !== undefined ? Utility.displayDateFormat(obj.FollowupDate) : "",
          is_Deleted: false,
        };
      });
      this.callLogsData = newArr;
    },
    newSOCallLogClicked() {
      this.callLogViewOnly = false;
      this.callLogSubmitBtnName = "Submit";
      this.soCallLogsDialog = true;
    },
    viewCallLogDetails(item) {
      this.conDate = item.ContactDateTime !== "" ? moment(item.ContactDateTime, "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DD") : "";
      this.conTime = item.ContactDateTime !== "" ? moment(item.ContactDateTime, "MM/DD/YYYY hh:mm:ss A").format("HH:mm") : "";
      this.followDate = item.FollowupDate !== "" ? moment(item.FollowupDate, "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DD") : "";
      this.recipientName = item.RecipientName;
      this.method = item.Method;
      this.outcome = item.Outcome;
      this.notes = item.Notes;
      this.nextAction = item.NextAction;
      this.selectedCallLogId = item.somast_callslog_id;
      this.callLogViewOnly = true;
      this.soCallLogsDialog = true;
    },
    editCallLogDetails(item) {
      this.conDate = item.ContactDateTime !== "" ? moment(item.ContactDateTime, "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DD") : "";
      this.conTime = item.ContactDateTime !== "" ? moment(item.ContactDateTime, "MM/DD/YYYY hh:mm:ss A").format("HH:mm") : "";
      this.followDate = item.FollowupDate !== "" ? moment(item.FollowupDate, "MM/DD/YYYY hh:mm:ss A").format("YYYY-MM-DD") : "";
      this.recipientName = item.RecipientName;
      this.method = item.Method;
      this.outcome = item.Outcome;
      this.notes = item.Notes;
      this.nextAction = item.NextAction;
      this.callLogSubmitBtnName = "Update";
      this.selectedCallLogId = item.somast_callslog_id;
      this.callLogViewOnly = false;
      this.soCallLogsDialog = true;
    },
    deleteCallLogDetails(item) {
      this.selectedCallLogId = item.somast_callslog_id;
      this.callLogDeleteDialog = true;
    },
    deleteCallLog() {
      const nowFormatted = moment().format("MM/DD/YYYY hh:mm:ss A");
      let LoaderDialog = { visible: true, title: "Please Wait..." };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .post("/so/so_call_log_upsert", {
          Pass: 3,
          somast_callslog_id: this.selectedCallLogId,
          so_key: this.salesOrderJson.so_id,
          ContactDateTime: nowFormatted,
          RecipientName: "",
          Method: "",
          Outcome: "",
          Notes: "",
          NextAction: "",
          FollowupDate: nowFormatted,
          Createdby: parseInt(this.userId),
          Modifiedby: parseInt(this.userId),
        })
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            const index = this.callLogsData.findIndex((x) => x.somast_callslog_id === this.selectedCallLogId);
            if (index !== -1) this.callLogsData[index].is_Deleted = true;
            this.callLogsData = [...this.callLogsData];
            let Alert = { type: "success", isShow: true, message: response.data.body.message };
            this.$store.commit("ConfigModule/Alert", Alert);
          } else {
            let Alert = { type: "error", isShow: true, message: response.data.message };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          this.callLogDeleteDialog = false;
          this.selectedCallLogId = 0;
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = { type: "error", isShow: true, message: Utility.apiError(error) };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
    soCallLogsUpdateSubmit() {
      if (!this.$refs.soCallLogForm.validate()) return;
      const isNew = this.callLogSubmitBtnName === "Submit";
      const payload = {
        Pass: isNew ? 1 : 2,
        somast_callslog_id: isNew ? 0 : this.selectedCallLogId,
        so_key: this.salesOrderJson.so_id,
        ContactDateTime: moment(`${this.conDate} ${this.conTime}`, "YYYY-MM-DD HH:mm").format("MM/DD/YYYY hh:mm:ss A"),
        RecipientName: this.recipientName,
        Method: this.method,
        Outcome: this.outcome,
        Notes: this.notes,
        NextAction: this.nextAction,
        FollowupDate: this.followDate
          ? moment(this.followDate, "YYYY-MM-DD").format("MM/DD/YYYY hh:mm:ss A")
          : moment().format("MM/DD/YYYY hh:mm:ss A"),
        Createdby: parseInt(this.userId),
        Modifiedby: parseInt(this.userId),
      };
      let LoaderDialog = { visible: true, title: "Please Wait..." };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .post("/so/so_call_log_upsert", payload)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            if (isNew) {
              this.getSOCallLogs();
            } else {
              const index = this.callLogsData.findIndex((x) => x.somast_callslog_id === this.selectedCallLogId);
              if (index !== -1) {
                this.callLogsData[index] = {
                  ...this.callLogsData[index],
                  ContactDateTime: payload.ContactDateTime,
                  FollowupDate: payload.FollowupDate,
                  RecipientName: payload.RecipientName,
                  Method: payload.Method,
                  Outcome: payload.Outcome,
                  Notes: payload.Notes,
                  NextAction: payload.NextAction,
                };
                this.callLogsData = [...this.callLogsData];
              }
            }
            let Alert = { type: "success", isShow: true, message: response.data.body.message };
            this.$store.commit("ConfigModule/Alert", Alert);
            this.soCallLogsDialogCancel();
            this.selectedCallLogId = 0;
          } else {
            let Alert = { type: "error", isShow: true, message: response.data.message };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = { type: "error", isShow: true, message: Utility.apiError(error) };
          this.$store.commit("ConfigModule/Alert", Alert);
        });
    },
   async labelDetails(label, dialogName, label_type) {
      let LoaderDialog = {
        visible: true,
        title: 'Please Wait...',
      };
      this.$store.commit('ConfigModule/LoaderDialog', LoaderDialog);
      this.labelDialogName = dialogName + " Details";
      this.labelType = label_type;
      if (label_type === "PDF") {
        this.labelRaw = label;
        this.labelLink = `data:application/pdf;base64,${label}#toolbar=0`;
      } else if (label_type === "IMG") {
        this.labelLink = `data:image/png;base64,${label}`;
      } else if (label_type === "GIF") {
        this.labelLink = `data:image/gif;base64,${label}`;
      } else {
        this.labelZpl = atob(label).replace(/\^POI/gi, "^PON");
        try {
          const response = await fetch(
            "https://api.labelary.com/v1/printers/8dpmm/labels/4x6/0/",
            {
              method: "POST",
              headers: {
                "Accept": "application/pdf",
                "Content-Type": "application/x-www-form-urlencoded"
              },
              body: this.labelZpl
            }
          );
          if (!response.ok) throw new Error(await response.text());
          const blob = await response.blob();
          this.labelLink = URL.createObjectURL(blob) + "#toolbar=0";
        } catch (error) {
          // Preview can't be rendered (eg. Labelary's 50-label cap) - printing still works via the direct-to-printer path below
          this.labelLink = "";
        }
      }
      this.labelDialog = true;
      LoaderDialog.visible = false;
      this.$store.commit('ConfigModule/LoaderDialog', LoaderDialog);
    },
    printLabel() {
      if (this.labelType === "IMG" || this.labelType === "GIF") {
        window.print();
      } else if (this.labelType === "PDF") {
        Utility.printZPLPDF(this.labelRaw, EncryptUtility.localStorageDecrypt("secondaryName"));
      } else {
        PrinterDetails.printLabelData(this.labelZpl, EncryptUtility.localStorageDecrypt("secondaryName"));
      }
    },
    async viewLabelHistory(item, dir) {
      let historyData = await salesOrderEditService.getSoLabelDetails("get", 1, item.recvr_id, this.userId, dir, 0);
      if (historyData?.Data) {
        this.labelHistoryData = historyData.Data;
        this.labelHistoryData.forEach((element) => {
          element.cdate = Utility.displayDateFormat(element.cdate);
        });
        this.labelHistoryDir = dir;
        this.labelHistorySorecpId = item.recvr_id;
        this.labelHistoryDialog = true;
      }
    },
    async viewLabelContent(historyItem) {
      let contentData = await salesOrderEditService.getSoLabelDetails(
        "get",
        2,
        this.labelHistorySorecpId,
        this.userId,
        this.labelHistoryDir,
        historyItem.solabel_id,
      );
      if (contentData?.Data?.[0]?.label) {
        const { label, label_type } = contentData.Data[0];
        await this.labelDetails(label, this.labelHistoryDir === "O" ? "Outbound" : "Inbound", label_type);
      }
    },
    closeLabelHistoryDialog() {
      this.labelHistoryDialog = false;
      this.labelHistoryDir = "";
      this.labelHistorySorecpId = 0;
      this.labelHistoryData = [];
    },
  },
  components: {
    breadcrumbComp,
    addressComp,
    BackToTop,
    DisplayCommentsComp,
    OrderTreeNode,
  },
};
